"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeAssignationStatuses = exports.AssignationStatus = void 0;
var AssignationStatus;
(function (AssignationStatus) {
    AssignationStatus[AssignationStatus["Pending"] = 0] = "Pending";
    AssignationStatus[AssignationStatus["Accepted"] = 1] = "Accepted";
    AssignationStatus[AssignationStatus["Declined"] = 2] = "Declined";
    AssignationStatus[AssignationStatus["Cancelled"] = 3] = "Cancelled";
})(AssignationStatus || (exports.AssignationStatus = AssignationStatus = {}));
exports.activeAssignationStatuses = [AssignationStatus.Pending, AssignationStatus.Accepted];
//# sourceMappingURL=AssignationStatus.js.map